import {Box, Pagination} from '@mui/material';
import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getBuildings, openModal} from '../actions';
import {Filters, Layout, PageHeader} from '../components';
import ComplexesTable from '../components/CustomTables/ComplexesTable';
import useFilters from '../utils/useFilters';

const Complexes = () => {
  const dispatch = useDispatch();
  const {user} = useSelector(s => s.user);
  const {buildings, buildingsLoading, buildingsPage, buildingsTotalPages} =
    useSelector(s => s.buildings);
  const filters = useFilters(val => dispatch(getBuildings(val)));

  const onAddComplex = () => {
    dispatch(openModal('AddComplexModal'));
  };

  const onPageChange = (e, value) => {
    dispatch(getBuildings({page: value, ...filters.filters}));
  };

  useEffect(() => {
    dispatch(getBuildings());
  }, []);

  return (
    <Layout>
      <PageHeader
        title="Projects"
        onAdd={!!user?.role && user?.role === 'SUPERADMIN' && onAddComplex}
      />
      <Filters withSearch {...filters} m="1rem !important" />
      <ComplexesTable buildings={buildings} loading={buildingsLoading} />
      {buildingsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={buildingsTotalPages}
            page={buildingsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Layout>
  );
};

export default Complexes;
